import { FaClock, FaMapMarkerAlt, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaUserCog, FaHome, FaDraftingCompass, FaHammer, FaTree, FaTasks, FaComments } from 'react-icons/fa';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'interior design':
      return <FaHome />; // Home

    case 'architecture planning':
      return <FaDraftingCompass />; // Drafting Compass

    case 'renovation services':
      return <FaHammer />; // Hammer

    case 'landscape design':
      return <FaTree />; // Tree

    case 'project management':
      return <FaTasks />; // Tasks

    case 'consultation services':
      return <FaComments />; // Comments


    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leaddesigner':
      return <FaUserCog />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Envelope icon

    default: 
      return null; // Return null if no matching icon is found
  }

};